import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class UpcomingAccountRenewalService {

  constructor(private http: HttpClient) { }

  url = environment.serverAPI4 + "/api/upcomingAccountRenewal";

  url2 = environment.serverAPI4 + "/api/overdueAccountRenewals";

  UpcomingAccountRenewal(query: string, page: number, size: number, sort: string, groupBy: any): Observable<Response[]> {

    const requestBody = {
      "searchQuery": query != null ? query.split("'").join('') : null,
      "groupBy": groupBy

    };

    const queryParams = `?page=${page}&size=${size}&sort=${sort}`;

    return this.http.post<Response[]>(`${this.url}/condition${queryParams}`, requestBody);
  }

  overdueAccountRenewals(query: string, page: number, size: number, sort: string, groupBy: any): Observable<Response[]> {

    const requestBody = {
      "searchQuery": query != null ? query.split("'").join('') : null,
      "groupBy": groupBy

    };

    const queryParams = `?page=${page}&size=${size}&sort=${sort}`;

    return this.http.post<Response[]>(`${this.url2}/condition${queryParams}`, requestBody);
  }
}
